import {useQuery} from '@tanstack/react-query';

import {getTopicChatMessages, GetTopicChatMessagesParams} from '../api';
import {QUERY__CHAT_TOPIC_MESSAGES} from '../queryKeys';
import {ChatMessage} from '../types';

import {GetListOutput, QueryOptionsForList} from '@/shared/api';

export const useGetTopicChatMessages = <
  SelectedData = GetListOutput<ChatMessage>,
>(
  params: GetTopicChatMessagesParams,
  options?: QueryOptionsForList<ChatMessage, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__CHAT_TOPIC_MESSAGES, params],
    queryFn: () => getTopicChatMessages(params),
    ...options,
  });
};
